import { render } from "./SocialStats.vue?vue&type=template&id=036c2b80"
import script from "./SocialStats.vue?vue&type=script&lang=js"
export * from "./SocialStats.vue?vue&type=script&lang=js"

import "./SocialStats.vue?vue&type=style&index=0&id=036c2b80&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__